/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainAdditionalTrainingType = 'FirstAidTraining' | 'CprTraining' | 'AnaphylaxisTraining' | 'AsthmaManagement' | 'DiabetesManagement' | 'Other';

export const DomainAdditionalTrainingType = {
    FirstAidTraining: 'FirstAidTraining' as DomainAdditionalTrainingType,
    CprTraining: 'CprTraining' as DomainAdditionalTrainingType,
    AnaphylaxisTraining: 'AnaphylaxisTraining' as DomainAdditionalTrainingType,
    AsthmaManagement: 'AsthmaManagement' as DomainAdditionalTrainingType,
    DiabetesManagement: 'DiabetesManagement' as DomainAdditionalTrainingType,
    Other: 'Other' as DomainAdditionalTrainingType
};